var components
try {
  components = {
    uGrid: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-grid/u-grid" */ "@/uni_modules/uview-ui/components/u-grid/u-grid.vue"
      )
    },
    uGridItem: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-grid-item/u-grid-item" */ "@/uni_modules/uview-ui/components/u-grid-item/u-grid-item.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-icon/u-icon" */ "@/uni_modules/uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uGap: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-gap/u-gap" */ "@/uni_modules/uview-ui/components/u-gap/u-gap.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.baseList, function (item, baseListIndex) {
    var $orig = _vm.__get_orig(item)
    var a0 = {
      paddingTop: 20 + "rpx",
    }
    return {
      $orig: $orig,
      a0: a0,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }